import { UnitKerjaJabatanDocument } from '~/apollo/gql/graphql'
import type { Option } from '~/types/form'

export const useSearchJabatanKepala = () => {
  const { result, loading, load, refetch } = useLazyQuery(UnitKerjaJabatanDocument, { limit: 100 })

  const jabatanKepalaOptions: ComputedRef<Option<string>[]> = computed(() => {
    if (!result.value) return []

    return result.value.unitKerjaJabatan.map(uker => ({
      label: uker.jabatan_name,
      value: uker.kode
    }))
  })

  const search = async (search: string) => {
    if (search === '') return []

    const loadedData = await load(null, { search, limit: 100 })
    if (!loadedData) {
      await refetch({ search, limit: 100 })
    }

    return jabatanKepalaOptions.value
  }

  return { loading, search }
}
